export const ReverseMapsStable = [
    ['Assertion', new Set(['target'])]
];
export const ReverseMapsForIdObjectsStable = [];
//# sourceMappingURL=reversemaps-stable.js.map